import { Card } from "antd";
import '../../styles/pdf.css';
const dashboardEmsa = () => {
    return (
        <Card size="small" title={<a href="/" >Dashboard de ausencias de tension</a>} style={{ width: "100%", height: "100" }}>
           <iframe className="pdf" style={{"border": 0}} width="100%" src="https://datastudio.google.com/embed/reporting/3005be0b-1677-43c6-b521-4e27af1e62d7/page/0G0WB"></iframe>
        </Card>
    )
}
export default dashboardEmsa;